import { styled } from '@mui/material/styles';
import { FormControlLabel } from '@mui/material';
import { isDark } from '../../styles';

const hidePrintRules = {
  '@media print': {
    display: 'none',
  },
};

export const SlideContainer = styled('div')(({ theme }) => ({
  borderRadius: 5,
  padding: theme.spacing(2),
  paddingTop: theme.spacing(1),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  maxWidth: 632,
  width: '90%',
  ...hidePrintRules,
}));

export const SlideWrap = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
  },
}));

export const ChartWrap = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});

export const SwitchControl = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  ...hidePrintRules,
}));

export const LoadBuffer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const TinyMarginTop = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(0.5),
}));

export const SmallMarginTop = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const containerStyles = (theme) => ({
  position: 'relative',
  paddingLeft: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),

  '& thead tr': {
    fontWeight: 'bold',
  },

  '& thead.headercells tr': {
    borderBottom: 'none !important',
    borderTop: 'none !important',
    marginLeft: theme.spacing(1),
  },

  '& thead.headercells td': {
    fontWeight: 'bold',
    borderLeft: 'none !important',
    borderRight: 'none !important',

    height: 250,
    whiteSpace: 'nowrap',

    '& > div': {
      transform: 'translate(0px, 107px) rotate(-90deg)',
      width: 40,
      letterSpacing: '0.75px',

      '& > span': {
        padding: '5px 10px',
      },
    },
  },

  '& tr > td:nth-child(1)': {
    fontSize: 14,
    width: 260,
    justifyContent: 'flex-start',

    '& span': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  '& td': {
    fontSize: 12,
  },
  '& tbody': {
    position: 'relative',
    top: -2,
    '&> tr > td:nth-child(1)': {
      marginLeft: theme.spacing(1),
    },
  },
});

const rowAverageStyles = (theme) => ({
  '& tr td:nth-child(2)': {
    borderRight: `1px solid ${isDark(theme) ? 'white' : 'black'}`,
    borderLeft: `1px solid ${isDark(theme) ? 'white' : 'black'}`,
  },
});

const twoColCompareStyles = (theme) => ({
  '& tr td.isTwoCol_0': {
    borderRight: `1px solid ${isDark(theme) ? 'white' : 'black'} !important`,
  },
  '& tr td.isTwoCol_1:nth-child(2)': {
    borderLeft: `1px solid ${isDark(theme) ? 'white' : 'black'} !important`,
  },
  '& .catHeader': {
    position: 'absolute',
    bottom: 15,
  },
});

// Wrapper that handles container + chartWrapEach + removeBox + (rowAverage|twoColCompare) variants
export const Container = styled('div', {
  shouldForwardProp: (prop) => !['isSingleChart', 'isRemoveBox', 'is2colcomp', 'isContainer'].includes(prop),
})(({ theme, isSingleChart, isRemoveBox, is2colcomp, isContainer }) => ({
  ...(isSingleChart && {
    width: `calc(100% - ${theme.spacing(1.5)})`,
    boxShadow: `0px 0px 6px rgba(0,0,0,0.5)`,
    margin: theme.spacing(0.5),

    [theme.breakpoints.up('xl')]: {
      width: `calc(50% - ${theme.spacing(2)})`,
      height: 450,
      overflow: 'auto',
    },
  }),
  ...(isContainer && containerStyles(theme)),
  ...(isRemoveBox && { boxShadow: 'none !important' }),
  ...(isContainer && (is2colcomp ? twoColCompareStyles(theme) : rowAverageStyles(theme))),
}));

export const ChartContainer = styled('div')({
  overflow: 'auto',
});

export const ChartRow = styled('tr', {
  shouldForwardProp: (prop) => prop !== 'noTopBorder',
})(({ theme, noTopBorder }) => ({
  display: 'flex',
  flexDirection: 'row',
  ...(noTopBorder && {
    borderTop: 'none !important',
    marginLeft: theme.spacing(1),
    '&> td': {
      borderBottom: `1px solid ${isDark(theme) ? 'white' : 'black'}`,
    },
  }),
}));

export const Col = styled('td', {
  shouldForwardProp: (prop) => !['hasBg', 'isLink'].includes(prop),
})(({ theme, hasBg, isLink }) => ({
  width: 40,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...(hasBg && { color: theme.palette.common.black }),
  ...(isLink && {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: isDark(theme) ? theme.palette.common.white : theme.palette.secondary.main,
  }),
}));
